<template>
    <div 
      class="detail-container"
      v-if="typeof this.$store.state.contractorLookup.violationPage === 'object' "
    >
        <div class="detail-box columns is-multiline is-centered is-12">
            <div class="column is-9">
                <div class="case-number is-size-3">
                    <div class="case-title ">
                        Case Files Associated:
                    </div>
                    <div
                        class="is-size-4 case-number"
                        v-for="(item, index) in this.$store.state.contractorLookup.violationPage"
                        :key="index"
                    >
                    {{ item[0]['casenumber'] }}
                    </div>
                </div>
            </div>
            <div class="column is-3">
                <div class="bottom-right-link">
                    <a
                        target="_blank"
                        href="https://www.phila.gov/departments/department-of-licenses-and-inspections/resources/applicable-codes/"
                    >
                        View applicable codes index <i class="fa fa-external-link" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </div>

      <div
        v-if="violationCodeInfo() !== null"
        class="violation-code-info"
      >
        <h1> {{ violationCodeInfo().descCode }} short description 
          <a @click="closeCodeDetail()">CLOSE<i class="fa fa-times fa-lg" aria-hidden="true"></i></a>  
        </h1>
        <p>
          {{ violationCodeInfo().description}}
        </p>
        <p>
        <br>
        <a
          class="code-full-desc"
          onclick=" window.open('http://www.amlegal.com/codes/client/philadelphia_pa/','_blank')"
        >
          View the full code {{ violationCodeInfo().code }}<i class="fa fa-external-link" aria-hidden="true"></i>
        </a>
        </p>
      </div>

      <v-client-table 
        class="table-light no-header column is-12"
        :data="tableData" 
        :columns="columns" 
        :options="options"
      />

      <!-- TODO - Add a table or header for each case number and the accordion for violations below it -->

      <div
        v-for="(item, index) in this.$store.state.contractorLookup.violationPage"
        :key="index"
      >
        <Accordion
          :contents="violations(item)"
          :label="item[0]['casenumber']"
          class="violations-accordion column is-12"
        >
          <div 
            class="contents-div"
            slot-scope="{ item }"
          >
            <v-client-table 
              class="contractor-violation-table table-light no-header"
              :data="violationTableData({item})" 
              :columns="columns" 
              :options="options"
            >
              <template
                slot="name"
                slot-scope="{row}"
                class="multi-cell"
              >
                <div v-if="(typeof row.name === 'string') && (row.id !== 'Zoning documents')">
                  <div class="multi-cell">
                    {{ row.name }}
                    <a 
                      v-if="row.id === 'code'"
                      @click="codeDetail({item})"
                    > 
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>

              </template>
            </v-client-table>
          </div>
        </Accordion>
      </div>
    </div>
</template>

<script>

import Accordion from '@/components/Accordion';
import _ from 'lodash';
import moment from 'moment';
const violationShortDesc  = require('../../assets/violationdescriptionsandexplanations.json');

export default {
  name: 'ContractorLicenseViolation',
  components: {
    Accordion, 
  },
  data() {
    return { 
      columns: ['id', 'name'],
      options: {
        filterable: false,
        sortable: [],
        highlightMatches: false,
        pagination: { 
          show: false, 
          virtual: false,
        },
        perPage: 100,
        columnsClasses: {
          id: 'violations table-id has-text-weight-bold',
          name: 'table-name',
        },
      },
    }
  },
  created() {
    console.log("Violation Page opening")
    if (!this.$store.state.detailPage.contactname) {
      this.getMoreLicenseDetailInfo();
    }
  },
  mounted() {
    // this.$store.commit('closeCodeDetail');
    // console.log("Violation Page opening")
   },
  destroyed(){
    // console.log("destroyed")
    this.$store.commit('closeCodeDetail');
    this.$store.commit('contractorLookup/closeViolationPage');
    this.$store.commit('closeDetail');
  },  
  computed: {
    detailInfo() {
      return this.$store.state.detailPage;
    },
    tableData(){
      let tableInfo = [
          { id: "License holder", 
            name: this.detailInfo.companyname ? this.detailInfo.companyname : this.detailInfo.contactname
          },
          { id: "License type", 
            name: this.detailInfo.licensetype
          },
          { id: "License number", 
            name: this.detailInfo.licensenumber
          },
      ]
      return tableInfo;
    },

  },
  methods: {
    codeDetail(value) {
      // console.log("openCodeDetail value: ", value.item);
      this.$store.commit('openCodeDetail', value.item);
      // console.log(this.$store.state);
    },
    closeCodeDetail() {
      this.$store.commit('closeCodeDetail');
    },
    violations(item){
      console.log("violation method: ", item);
      let violationArray = [];
      item.forEach(function(a){
        let violation = new Object();
          violation.code = a.violationcode;
          violation.title = "Violation number: " + a.violationnumber + " - " + a.violationcode;
          violation.type = a.violationcodetitle ? a.violationcodetitle : 'Not Available';
          violation.date = moment(a.violationdate).isValid ? moment(a.violationdate).format('MMM DD, yyyy') : "Not Available";
          violation.descCode = a.violationcode;
          // console.log(a.violationcode, _.filter(violationShortDesc, { "Violation Type": a.violationcode}))
          violation.description = _.filter(violationShortDesc, { "Violation Type": a.violationcode})[0] ?
           _.filter(violationShortDesc, { "Violation Type": a.violationcode})[0]["Violation Explanation"]: "Not Available";

          violationArray.push(violation);
        }
      );
      return violationArray
    },
    violationCodeInfo(){
      // console.log(this.$store.state.violationCodeInfo)
      return this.$store.state.violationCodeInfo
    },
    violationTableData({item}){
      // console.log(item);
      // item.forEach( a => console.log(a));
      const constItem = item;
      let tableData = [];
      const idList = ['code', 'type', 'date'];
      idList.forEach( each => {
        // console.log(each);
        let row = new Object();
        let heading = each === 'type' ? 'Violation code title' : each;
        row.id = heading
        row.name = constItem[each]
        tableData.push(row);
      });
      // console.log("Table data for violation: ", tableData)
      return tableData;
    },
    getMoreLicenseDetailInfo() {
      // console.log("getMoreDetailInfo called");
      this.$store.dispatch('getMoreLicenseDetailInfo', this.detailInfo.licensenumber);
    },
  },
}
</script>
<style lang="scss">

.accordion-title {
  margin-left: 10px;
}

.accordion-container {
  padding-left: 10px;
  font-size: 1.35rem;
  &.violations-accordion {
    margin: 5px auto;
  }
  div {
    font-size: initial;
    padding-left: initial;
  }
}



.case-number {
  line-height: initial;
}

.detail-box  {
  position: relative;
  background-color: $ben-franklin-blue-light;
  margin: 0;
  clear: both;
  padding: 15px 5px 15px 25px;
  // & .column {
  //   padding: 0;
  // }
  .case-title {
    text-transform: uppercase;
  }
  .case-number {
    text-transform: uppercase;
    // padding: 5px 0 15px 0;
  }
  .bottom-right-link {
    right: 15px;
    bottom: 15px;
  }
  .column.is-9 {
      padding-left: 0;
  }

}

.no-header th {
  display: none !important;
}

.contractor-violation-table .violations.table-id.has-text-weight-bold {
  text-transform: capitalize;
}

.violations-accordion>div.accordion-question {
  padding: 0 15px;
  background: $ghost-grey;
  border-bottom: none;
  border-spacing: 0 14px;
  border-collapse: separate;
} 

.violations-accordion .table-light {
  th, tr, td {
    background: $ghost-grey;
  }
}
// .accordion-container .violations-accordion {
//     margin-top: 0 !important;
// }

.violation-code-info {
  background: $ghost-grey;
  overflow-y: scroll;
  width: 100%;
  max-width: 750px;
  height: 350px;
  position: fixed;
  margin: auto;
  z-index: 999;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 25px;
  box-shadow: 0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  h1 {
    font-weight: 600;
    padding-bottom: 20px;
    a {
      float: right;
    }
  }
  p>a {
    margin-top: 15px;
    font-weight: 100;
  }
  .fa-times {
    vertical-align: -0.08em;
  }
  button.code-full-desc {
    border: 2px solid $ben-franklin-blue-dark;
    color: $ben-franklin-blue-dark;
    padding: 12px;
    margin-top: 35px;
    margin-left: auto;
    margin-right: auto;
    display: flow-root;
    cursor: pointer;
    i {
      margin-left: 10px;
    }
  }
}

</style>